import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const BillingPage = lazy(() => import('./BillingPage'));
const path = 'reports/billing/base';

const BillingRoute: FuseRouteItemType = {
	path: path,
	element: <BillingPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Billing',
					showCrumbs: false,
					helpName: 'Billing Base'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default BillingRoute;
